(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('MedFrequencyToSearch', MedFrequencyToSearch);

    MedFrequencyToSearch.$inject = ['$resource'];

    function MedFrequencyToSearch($resource) {
        var resourceUrl =  'api/_search/med-frequency-tos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
